module.exports = __webpack_public_path__ + "static/sample-15-c947d23e26b1bbaf6fe45be0f8d8d159.png";